<div *ngFor="let item of messages; trackBy: TrackByFunction">
  <labs-toast-item [toast]="item" @slideIn @slideOut style="font-size: 12px;">
  </labs-toast-item>
</div>
